import request from '@/utils/request'

// 商场列表
export async function api_getMallList(params) {
  return request({
    url: '/rest/mall/page',
    method: 'get',
    params,
    loading: true
  })
}

// 修改商场
export async function api_putMallEdit(params) {
  return request({
    url: '/rest/mall/outOrganizationId/update',
    method: 'put',
    params,
    loading: true
  })
}
